export default __webpack_public_path__ + "static/media/quiz-preview.00b7ff6b.png";